import './styles.scss'
import React from 'react'
import { Dialog } from 'primereact/dialog'
import { useTranslation } from 'react-i18next'
import { coffeewebLogo } from 'Utils/Constants'
import { AppleIcon, GooglePlay } from 'Assets/Icons'

function ComingSoonModal({ showModal, setShowModal, showText = true, customClassName = '' }) {
  const { t } = useTranslation()

  const handleClose = () => {
    setShowModal(false)
  }

  const headerContent = (
    <div className="user-guide-header-content">
      <i className="pi pi-times-circle" onClick={handleClose}></i>
    </div>
  )

  const footerContent = (
    <div className="user-guide-dialog-footer">
      <div className="social-buttons-container">
        <div className="social-buttons">
          <div className="flex">
            <a className="app-btn blu flex vert" href="https://apps.apple.com/in/app/coffeeweb/id1618878403" target="_blank" rel="noreferrer">
              <AppleIcon fill={'#fff'} className="social-images" />
              <p>
                {t('DOWNLOAD_ON_THE')}
                <br /> <span className="big-txt">{t('APP_STORE')}</span>
              </p>
            </a>
            <a className="app-btn blu flex vert" href="https://play.google.com/store/apps/details?id=com.coffeeweb.app" target="_blank" rel="noreferrer">
              <img alt="GooglePlay" src={GooglePlay} className="social-images" />
              <p>
                {t('GET_IT_ON')} <br /> <span className="big-txt">{t('GOOGLE_PLAY')}</span>
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div>
      <Dialog visible={showModal} closable={false} header={headerContent} footer={footerContent} className={`user-guide-dialog ${customClassName}`}>
        <div className="user-guide-dialog-container" data-testid="user-guide-dialog-container">
          <div className="logo-container" data-testid="logo-container">
            <img data-testid="coffeeWeb-logo" src={coffeewebLogo.coloredLogo} alt="coffeeweb-logo" className="logo-image" />
          </div>
          <div className="coming-soon-div">
            <p className="coming-soon-text">{t('COMING_SOON')}</p>
          </div>{' '}
          {showText && (
            <div className="description-div">
              <div className="description-text" data-testid="dialog-modal-description">
                {t('PLATINUM_SUBSCRIPTION_UPDATE')}
              </div>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  )
}

export default ComingSoonModal
